import cn from 'clsx'

import { TestimonialBox, type TestimonialBoxProps } from './testimonial-box'

import css from './testimonial-carousel.module.css'
import { Carousel } from '@/components/Carousel/Carousel'

export type TestimonialCarouselProps = {
    /** React node (Rich HTML) can replace the string properties in the Testimonial collection. */
    testimonials: TestimonialBoxProps[]
    previousButtonLabel: string
    nextButtonLabel: string
    className?: string
    /** id of carousel to pass in, in case there are more than 1 carousel in the same page */
    id?: string
}

export function TestimonialCarousel({
    testimonials,
    previousButtonLabel = 'Previous',
    nextButtonLabel = 'Next',
    className,
    id,
}: TestimonialCarouselProps) {
    return (
        <div className={cn([className, css.container])}>
            <Carousel
                id={id}
                className={css.carousel}
                variant="testimonial"
                previousButtonLabel={previousButtonLabel}
                nextButtonLabel={nextButtonLabel}
                dotIndicatorLabels={testimonials.map((t) => t.alt ?? '')}
                repeat
            >
                {testimonials.map((testimonial, i) => (
                    // biome-ignore lint/suspicious/noArrayIndexKey: explanation ;-)
                    <TestimonialBox key={i} {...testimonial} />
                ))}
            </Carousel>
        </div>
    )
}
